import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useSymptomStore } from 'store/symptom';
import SymptomContainer from './components/SymptomContainer';
import { checkSpanishLocale } from 'lib/utils';
import useSymptomChecker from 'hooks/useSymptomChecker';
import { Textarea } from 'components/ui/textarea';

export default function SymptomOtherBodyPart() {
  const { t } = useTranslation();
  const questionData = useSymptomStore((store) => store.questionData)?.data;

  const isSpanish = checkSpanishLocale();

  const [bodyPart, setBodyPart] = useState('');

  useEffect(() => {
    if (questionData?.user_eng_choices || questionData?.user_spanish_choices) {
      const selected =
        questionData?.[isSpanish ? 'user_spanish_choices' : 'user_eng_choices'];
      setBodyPart(selected || '');
    }
  }, [isSpanish, questionData]);

  const { onSubmit, isLoading } = useSymptomChecker();

  const onContinue = () => {
    onSubmit({
      eng_choices: bodyPart,
      spanish_choices: bodyPart,
      questionData,
    });
  };
  return (
    <SymptomContainer
      questionData={questionData}
      isLoading={isLoading}
      onContinue={onContinue}
      questionNumber={1}
      disabled={!bodyPart}
    >
      <div className='flex-1 mb-10 md:mb-20'>
        <Textarea
          placeholder={`${t('type_here')}...`}
          value={bodyPart}
          onChange={(e) => setBodyPart(e.target.value)}
          autoFocus
          className='text-sm border-t-0 border-b-2 border-l-0 border-r-0 rounded-none border-primary bg-background focus-visible:ring-0 focus-visible:ring-offset-0'
        />
      </div>
    </SymptomContainer>
  );
}
